// The AMS360 web address card in Settings, Integrations: its words and the address check, the same
// rule as the server (apps/server/src/ams360/links.ts).
import type { SettingChange } from '../auth/api';
import { stamp } from './code-rule-lines';

export const amsAddressCopy = {
  title: 'AMS360 web address',
  sub: 'Where every Open in AMS360 link starts',
  label: 'Address with the agency version',
  test: 'Test link',
  note: 'AMS360 needs the version at the end. If Open in AMS360 shows an AMS360 error page after an AMS360 update, sign in to AMS360, copy the address up to the version, and save it here.',
  defaultLine: (d: string) => `Default: ${d}.`,
  invalid: 'Enter the address as AMS360 shows it, like https://www.ams360.com/v2623881.',
  cancel: 'Cancel',
  save: 'Save',
  saved: 'AMS360 web address saved.',
  unsaved: 'Unsaved changes',
  history: (n: number) => `History (${n})`,
  hideHistory: 'Hide history',
  noHistory: 'No changes yet.',
  somethingWrong: 'Something went wrong. Try again.',
} as const;

/** The address as the portal keeps it, or null: only www.ams360.com with the version. */
export function parseAmsAddress(raw: string): string | null {
  const t = raw.trim().replace(/\/+$/, '');
  const m = /^https:\/\/www\.ams360\.com\/(v\d{3,12})$/i.exec(t);
  return m ? `https://www.ams360.com/${m[1].toLowerCase()}` : null;
}

export function amsHistoryRow(change: SettingChange) {
  return {
    when: `${stamp(change.at)}, ${change.by ?? 'Inflowmate'}`,
    field: amsAddressCopy.title,
    before: String(change.before ?? ''),
    after: String(change.after ?? ''),
  };
}
